import { createSlice } from '@reduxjs/toolkit'

const ViewCourseLessonStatus = Object.freeze({
    Loading: 'loading',
    Success: 'success',
    Failure: 'failure',
})

const initialState = {
    status: null,
    errorMessage: '',
    topicContents: [],
}

const viewCourseLessonSlice = createSlice({
    name: 'viewCourseLesson',
    initialState,
    reducers: {
        getTopicContentsRequest(state) {
            state.status = ViewCourseLessonStatus.Loading
            state.errorMessage = ''
        },
        getTopicContentsRequestSuccess(state, action) {
            state.status = ViewCourseLessonStatus.Success
            state.topicContents = action.payload
        },
        getTopicContentsRequestFailure(state, action) {
            state.status = ViewCourseLessonStatus.Failure
            state.errorMessage = action.payload
        },
    },
})

const {
    getTopicContentsRequest,
    getTopicContentsRequestSuccess,
    getTopicContentsRequestFailure,
} = viewCourseLessonSlice.actions

export const viewCourseLessonActions = {
    getTopicContentsRequest,
    getTopicContentsRequestSuccess,
    getTopicContentsRequestFailure,
}

export const viewCourseLessonSelectors = {
    isFetching: state =>
        state.viewCourseLesson.status === ViewCourseLessonStatus.Loading,
    hasError: state =>
        state.viewCourseLesson.status === ViewCourseLessonStatus.Failure,
    status: state => state.viewCourseLesson.status,
    errorMessage: state => state.viewCourseLesson.errorMessage,
    topicContents: state => state.viewCourseLesson.topicContents,
}

export default viewCourseLessonSlice.reducer
